import React from 'react';
import { useQuery } from '@tanstack/react-query';
import styles from '../TradeFlowTrackingTab.module.css';
import { getSmartPool, SmartPoolEntry } from '../../../services/tradeFlowAdminApi';

const SMART_POOL_KEY = ['admin', 'trade-flow', 'smart-pool'];

const SmartPoolSection: React.FC = () => {
  const { data: result, isLoading, isError, error, refetch } = useQuery({
    queryKey: SMART_POOL_KEY,
    queryFn: getSmartPool,
    refetchInterval: 15000, // auto-refresh every 15s
  });

  const data = result?.data ?? [];
  const total = result?.total ?? 0;
  const updatedAt = result?.updated_at ?? null;

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2>Smart Pool</h2>
        <span className={styles.sectionBadge}>Tab 6</span>
        {updatedAt && (
          <span className={styles.refreshInfo}>
            Updated: {new Date(updatedAt).toLocaleTimeString()}
          </span>
        )}
        <button onClick={() => refetch()} className={styles.refreshButton} disabled={isLoading}>
          Refresh
        </button>
      </div>
      <p className={styles.sectionDescription}>
        Top-ranked recommendations from the AI scoring system before they enter Active or Reserve pools.
        Auto-refreshes every 15 seconds.
      </p>

      {isError && <div className={styles.errorBanner}>{(error as Error)?.message || 'Failed to fetch Smart Pool'}</div>}

      {isLoading ? (
        <div className={styles.loadingState}>Loading Smart Pool...</div>
      ) : data.length === 0 ? (
        <div className={styles.emptyState}>Smart Pool is empty. No recommendations available.</div>
      ) : (
        <table className={styles.dataTable}>
          <thead>
            <tr>
              <th>Rank</th>
              <th>Symbol</th>
              <th>Score</th>
              <th>Confidence</th>
              <th>Entry</th>
              <th>Direction</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {data.map((entry, idx) => (
              <tr key={entry.recommendation_id}>
                <td><span className={styles.rankBadge}>{idx + 1}</span></td>
                <td className={styles.mono}>{entry.symbol}</td>
                <td className={styles.mono}>{entry.score.toFixed(0)}</td>
                <td>
                  {entry.confidence !== null
                    ? `${(entry.confidence * 100).toFixed(1)}%`
                    : '-'}
                </td>
                <td className={styles.mono}>
                  {entry.entry !== null ? entry.entry.toFixed(6) : '-'}
                </td>
                <td>{entry.direction || '-'}</td>
                <td className={styles.monoSmall}>
                  {entry.created_at ? new Date(entry.created_at).toLocaleString() : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SmartPoolSection;
